import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { requestRecall } from "../../../utils/API/requestRecall";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

const RecallConfirmation = ({ open, onOk, onCancel, selectedRowData }) => {
  const dispatch = useDispatch();
  const handleRequestCancel = async () => {
    const projectId = selectedRowData["Project"];
    const requestId = selectedRowData["requestId"];

    try {
      const formData = {
        projectId: projectId,
        requestId: requestId,
      };
      // console.log(formData)
      await requestRecall(formData, dispatch);
      onOk();
    } catch (error) {
      toast.error("No Request Present");
    }
  };
  return (
    <DiaglogBox width={400} onCancel={onCancel} open={open}>
      <div className="pb-5">
        <h4
          className="pt-8 pb-9 w-full text-black text-[1.5625rem] font-bold text-center"
          style={{
            background: "url('/images/purple_wave_bg.svg')",
            backgroundRepeat: "no-repeat",
          }}
        >
          Notification
        </h4>
        <p className="text-center text-[17px] font-medium px-11">
          Are you sure you want to cancel this Transfer Request ?
        </p>
        <div className="px-10 flex justify-between mt-4">
          <Button
            color={"blue"}
            className={"w-[150px] h-[40px] text-white text-sm font-bold"}
            varient={"primary"}
            onClick={handleRequestCancel}
          >
            Yes
          </Button>

          <Button
            borderColor={"blue"}
            className={"w-[150px] h-[40px] text-blue-800 text-sm font-bold"}
            varient={"primary"}
            onClick={onCancel}
          >
            No
          </Button>
        </div>
      </div>
    </DiaglogBox>
  );
};

export default RecallConfirmation;
